import { Chart, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningPerformanceBuyToMarket extends Layout {
    chartBuyToMarket: Chart;
    sourceBPPerfBuyToMarket: DataSource;
    tableBPPerfBuyToMarket: Table;
}
